import React, { Component, useEffect } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import {
  APIHandler,
  DataHandler,
  StorageHandler,
  RegisterTypeSelect,
  RegisterTrade,
  RegisterExhibitor,
  RegisterPress,
  RegisterConsumer,
  RegisterIndustryVisitor,
  Introduction,
  CheckDatabase,
} from 'C4';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import whiteLogo from 'assets/images/logo/logo.png';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  const emptyFields = [];
  Object.values(inputs).forEach(function (input) {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 1') {
        name = 'salutation';
      }
      emptyFields.push(name);
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      let name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 2') {
        name = 'Main Affiliation?';
      }
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
  });

  return (
    inputArray.every((val) => val.checkValidity() === true) &&
    selectArray.every((val) => val.selectedIndex !== 0)
  );
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export const userInputBlank = {
  email: '',
  reg_email: '',
  reg_password: '',
  reg_passwordConfirm: '',
  reg_agency_name: '',
  reg_first_name: '',
  reg_last_name: '',
  reg_experience: '',
  reg_owner: 0,
  reg_city: '',
  reg_state: '',
  reg_zip_code: '',
  reg_country: '',
  reg_title: '',

  reg_phone_number: '',
  reg_mobile_phone_number: '',
  reg_host_agency_name: '',

  reg_agency_business: '',
  reg_agency_affiliation: '',

  europe: true,
  family: false,
  adventure: false,
  aars: false,
  luxury: false,
  romance: false,
  europe: false,

  reg_travel_type_1: '',
  reg_travel_type_2: '',
  reg_travel_type_3: '',

  reg_destination_1: '',
  reg_destination_2: '',
  reg_destination_3: '',

  reg_annual_sales: '',

  reg_id_number: '',
  reg_id_type: '',

  reg_custom_1: '',
  reg_custom_2: '',
  reg_custom_3: false,

  reg_website: '',
  marketing_travel_brands: false,
  registration_code: '',
};

const Form = ({ backHandler, registerHandlerSSO, changeHandler, path, userInput, animation }) => {
  let exhibitorPath = '/exhibitor';

  useEffect(() => {
    autofill();
  }, [userInput.registration_code]);

  const autofill = () => {
    const inputs = Array.from(document.getElementsByTagName('input'));
    const selects = Array.from(document.getElementsByTagName('select'));

    Object.entries(userInput).forEach(([key, value]) => {
      if (value && value !== '') {
        let input = inputs.find((i) => i.name === key);

        if (input) input.value = value;
        else {
          let select = selects.find((i) => i.name === key);
          if (select) select.value = value;
        }
      }
    });
  };

  return (
    <React.Fragment>
      <div className="RegisterHolder">
        <RegisterTypeSelect
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={(e) => {
            changeHandler(e);
            // autofill();
          }}
          loadingAnimRegister={animation.loadingAnimRegister}
          default="agent"
          path={path}
        />
      </div>

      {window.location.pathname !== '/exhibitor' && (
        <div className="step">STEP 2: Confirm Email and Create Password</div>
      )}
      {path === exhibitorPath && (
        <RegisterExhibitor
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />
      )}

      {userInput.registration_code === 'consumer' && (
        <RegisterConsumer
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />
      )}

      {userInput.registration_code === 'press' && (
        <RegisterPress
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />
      )}

      {userInput.registration_code === '' && path !== exhibitorPath && (
        <RegisterTrade
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />
      )}

      {userInput.registration_code === 'agent' && (
        <RegisterTrade
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
        />
      )}

      {userInput.registration_code === 'industry_visitor' && (
        <RegisterIndustryVisitor
          passwordField
          back={backHandler}
          submit={registerHandlerSSO}
          change={changeHandler}
          loadingAnimRegister={animation.loadingAnimRegister}
          userInput={userInput}
        />
      )}

      <ToastContainer />
    </React.Fragment>
  );
};

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: userInputBlank,
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      form: '',
      redirect: '',
      appId: 0,
      admission_message: '',
      verified_message: '',
      resend_link: '',
      page: 'email',
    };

    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.registerHandlerSSO = this.registerHandlerSSO.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.batchChangeHandler = this.batchChangeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.signUpRoute = this.signUpRoute.bind(this);
    this.forgotPasswordRoute = this.forgotPasswordRoute.bind(this);
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId().then((id) => {
      this.setState({ appId: id });
    });
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    document.querySelector('.form__message').style.color = 'red';
    document.querySelector('.form__message').style.opacity = 1;
    document.querySelector('.form__message').style.color = 'black';
  }

  backHandler() {
    this.setState({
      display: 'login',
      message: '',
    });
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  signUpRoute() {
    this.setState({ display: 'registerPassword' });
  }

  forgotPasswordRoute() {
    this.setState({ display: 'forgot' });
  }

  async loginHandler(
    event,
    email = this.state.userInput.email,
    password = this.state.userInput.password,
  ) {
    const submit = event.target;
    submit.disabled = true;
    console.log('submit1');
    if (checkInputValidity()) {
      event.preventDefault();
      console.log('submit2');

      const exists = await StorageHandler.exists(storageKeys.user);
      if (!exists) {
        const response = await APIHandler.loginUser(email, password);
        console.log('submit3');

        if (response.error || response.success === false) {
          submit.disabled = false;
          toast.error(response.message, {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return;
        }

        StorageHandler.save(storageKeys.accessToken, response.access_token);
        StorageHandler.save(storageKeys.refreshToken, response.refresh_token, response.expires_in);
        this.setAnim('loadingAnim', true);
        submit.disabled = true;
        console.log('submit4');

        const appId = await DataHandler.matchAppId();
        const user = await APIHandler.getUser(appId, response.access_token);
        if (Object.keys(user).length > 0) {
          this.login(user, true);
          return;
        }
      }
      StorageHandler.load(storageKeys.user).then((userInfo) => {
        // Loads userInfo from localStorage
        submit.disabled = false;
        this.login(userInfo, false);
      });
    } else {
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
    }
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value || event.target.checked;
    this.setState({ userInput: input });
  }

  batchChangeHandler(newInput) {
    this.setState({ userInput: newInput });
  }

  registerHandler(email, password) {
    this.setAnim('loadingAnimRegister', true);
    const info = this.state.userInput;

    if (checkInputValidity()) {
      let regCode = 'attendee';
      if (window.location.pathname == '/exhibitor') {
        regCode = 'exhibitor';
      }
      let marketing_opt_in = info.marketing_opt_in;
      if (marketing_opt_in === null) {
        marketing_opt_in = false;
      }
      const registerObject = {
        first_name: info.reg_first_name,
        last_name: info.reg_last_name,
        name: info.reg_first_name + ' ' + info.reg_last_name,
        agency_name: info.reg_agency_name,
        state: info.reg_state,
        country: 'US',

        experience: info.reg_experience,
        owner: info.reg_owner,
        state: info.reg_state,
        city: info.reg_city,
        zip_code: info.reg_zip_code,
        title: info.reg_title,

        phone: info.reg_phone_number,
        mobile_phone: info.reg_mobile_phone_number,
        host_agency_name: info.reg_host_agency_name,

        agency_business: info.reg_agency_business,
        agency_affiliation: info.reg_agency_affiliation,

        travel_type_1: info.reg_travel_type_1,
        travel_type_2: info.reg_travel_type_2,
        travel_type_3: info.reg_travel_type_3,

        destination_1: info.reg_destination_1,
        destination_2: info.reg_destination_2,
        destination_3: info.reg_destination_3,
        annual_sales: info.reg_annual_sales,

        custom_1: info.reg_custom_1,
        custom_2: info.reg_custom_2,
        custom_3: info.reg_custom_3,
        custom_4: this.props.path,

        id_type: info.reg_id_type,
        id_number: info.reg_id_number,

        agency_website: info.reg_website,

        registration_code: regCode,
        marketing_opt_in: marketing_opt_in,
        custom_5: info.custom_5,
        marketing_travel_brands: info.marketing_travel_brands,

        aars: this.state.userInput.aars,
        luxury: this.state.userInput.luxury,
        romance: this.state.userInput.romance,
        family: this.state.userInput.family,
        adventure: this.state.userInput.adventure,
        europe: this.state.userInput.europe,
      };

      DataHandler.matchAppId().then((appId) => {
        APIHandler.setUser(info.reg_email, appId, registerObject).then((response) => {
          APIHandler.setShows(info.reg_email, registerObject).then((res) => {
            toast.success(
              'Successfully registered, you now will be redirected to the profile image page.',
              {
                position: 'bottom-center',
                transition: Zoom,
                autoClose: 10000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              },
            );

            localStorage.setItem('registerSuccessful', true);

            const apps = [];
            if (registerObject.europe === true) {
              apps.push(100);
            }
            if (registerObject.aars === true) {
              apps.push(48);
            }
            if (registerObject.adventure === true) {
              apps.push(48);
            }
            if (registerObject.luxury === true) {
              apps.push(179);
            }
            if (registerObject.romance === true) {
              apps.push(178);
            }

            StorageHandler.save(storageKeys.registeredApps, apps);

            this.setAnim('loadingAnimRegister', false);
            window.location.href = '/count-down';
            window.postMessage('success');
            window.ReactNativeWebView.postMessage('success');
          });
        });
      });
    } else {
      toast.error('Please fill in all the required fields', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setAnim('loadingAnimRegister', false);
    }
  }

  async registerHandlerSSO(event) {
    console.log('2');

    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    this.setAnim('loadingAnimRegister', true);

    console.log('1');
    const name = `${this.state.userInput.reg_first_name} ${this.state.userInput.reg_last_name}`;
    const email = this.state.userInput.reg_email;
    const company = this.state.userInput.reg_agency_name;
    const password = this.state.userInput.reg_password;
    const passwordConfirm = this.state.userInput.reg_passwordConfirm;
    // if (this.props.path !== '/exhibitor') {
    //   if (!this.state.userInput.marketing_opt_in || !this.state.userInput.marketing_opt_in_2) {
    //     toast.error('The Stay Connected! and Stay Informed! checkboxes are required to complete your registration.', {
    //       position: 'bottom-center',
    //       transition: Zoom,
    //       autoClose: 10000,
    //       hideProgressBar: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //     });
    //     submit.disabled = false;
    //     this.setAnim('loadingAnimRegister', false);
    //     return;
    //   }
    // }
    console.log('3');

    if (!checkInputValidity()) {
      const invalidFields =
        'Please fill in all the required fields: ' + checkInputValidityFields().join(', ');
      toast.error(invalidFields, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });

      event.preventDefault();
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password !== passwordConfirm) {
      toast.error('The passwords you entered do not match', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password.length < 8) {
      toast.error('Your password needs to be a minimum of 8 characters', {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    console.log('4');

    APIHandler.registerSSOUser(name, email, company, password, passwordConfirm).then((SSOUser) => {
      if (
        SSOUser.success === false &&
        SSOUser.message !== 'This email has already been registered.'
      ) {
        toast.error(
          'This email address already exists or is invalid. Please try with another email address',
          {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        submit.disabled = false;
        this.setAnim('loadingAnimRegister', false);
      } else {
        // Old school register
        this.registerHandler(email, password);
      }
    });
  }

  forgotHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { email } = this.state.userInput;
    this.setAnim('loadingAnimForgot', true);
    APIHandler.forgotPassword(email).then((res) => {
      if (res.status !== 200) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error("The email address you entered doesn't exist.", {
          position: 'bottom-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.success(
          res.message.concat(
            '\n Successfully registered! You will be redirect to the profile image page.',
          ),
          {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 0,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        window.setTimeout(() => {
          window.location.href = '/count-down';
        }, 10);
      }
    });
  }

  resendHandler() {
    APIHandler.resendVerificationLink(this.state.resend_link).then((res) => {
      if (res.success) {
        toast.success(res.message, {
          position: 'bottom-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ resend_link: '' });
      }
    });
  }

  render() {
    const { animation, display, message, redirect, userInput, page } = this.state;

    return (
      <form className="login__form">
        <div id="scrollfix">
          <Form
            backHandler={this.backHandler}
            registerHandlerSSO={this.registerHandlerSSO}
            changeHandler={this.changeHandler}
            path={this.props.path}
            userInput={userInput}
            animation={animation}
          />

          <br />
          <br />
          <br />
          <hr />

          {redirect.length > 0 && <Redirect push to={redirect} />}
          <p className="legal">
            {i18n.translate('loginScreen.tAndC.agree')}
            <span
              role="button"
              tabIndex={-1}
              data-fancybox="privacy"
              data-type="iframe"
              href="https://travpromobile.com/privacy_policy.html"
            >
              {i18n.translate('loginScreen.tAndC.privacyPolicy')}
            </span>
            {i18n.translate('loginScreen.tAndC.and')}
            <span
              role="button"
              tabIndex={0}
              data-fancybox="terms"
              data-type="iframe"
              href="https://travpromobile.com/terms_of_use.html"
            >
              {i18n.translate('loginScreen.tAndC.termsConditions')}
            </span>
            .
          </p>
          <SweetAlert
            html
            onConfirm={() => {
              this.setState({ admission_message: '' });
            }}
            show={!!this.state.admission_message}
            confirmButtonText="Ok"
            text={this.state.admission_message}
          />
          <SweetAlert
            html
            title="Email not Verified:"
            onConfirm={() => {
              this.setState({ verified_message: '' });
            }}
            onCancel={() => {
              this.setState({ verified_message: '' });
              this.resendHandler();
            }}
            show={!!this.state.verified_message}
            confirmButtonText="Ok"
            cancelButtonText="Resend email"
            showCancelButton
            text={this.state.verified_message}
          />
          <ToastContainer draggablePercent={70} />
        </div>
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
